import packageJson from '../../package.json';
import {devExternalKeys} from './external-keys';

export const environment = {
  production: false,
  version: packageJson.version + ' - Develop',
  apiBaseUrl: 'https://develop.sipub.com.br:6060',
  mockApiBaseUrl: 'https://localhost:3000',
  apiVersions: {
    v1: '/v1',
    v2: '/v2'
  },
  publicLighting: {
    // Troque para false para voltar temporariamente ao endpoint regional legado.
    useGlobalDevicePositions: true,
    userPositionsRefreshIntervalMs: 60_000,
  },
  geoRoutes: {
    coordinatePhotos: '/geo/coordinate/photo',
    report: '/geo/report',
  },
  support: {
    whatsappPhone: '+557398509578',
    whatsappMessage: 'Olá!'
  },
  temporaryPrivileges: {
    enabled: true,
  },
  auditCenter: {
    // A chave nunca vai para o bundle. O front chama apenas o proxy local de teste.
    aiProxyUrl: '/mock-api/v2/public-illumination/audit/ai-analysis',
    aiModel: 'gpt-5-mini',
  },
  externalKeys: devExternalKeys
};
